module.exports = __webpack_public_path__ + "static/media/Flashbang-Rafiki-cards_hearts-8.cfa70f3b.svg";